$(document).ready(function () {
  const idiomas = function idiomas() {
    const documentHTML = $('html');

    if (documentHTML[0].lang === "pt") {
      documentHTML[0].lang = "en";
      loaddingComponents();
      menuBuble();
      setTimeout(function () {
        // Troca o texto do menu e variável de verificação para português
        $('[data-click="idioma"]').text('Português');
        $('[data-click="idioma-footer"]').text('Português');

        if ($('.conteudo').attr('class').split(' ')[1] === 'home') {
          trocaIdioma();
        } else if ($('[data-page]').attr('data-page') === 'case-dell-vale') {
          trocaIdioma();
        } else if ($('[data-page]').attr('data-page') === 'case-mitsubishi') {
          trocaIdioma();
        } else if ($('[data-page]').attr('data-page') === 'case-pompom') {
          trocaIdioma();
        } else if ($('[data-page]').attr('data-page') === 'case-royal-canin') {
          trocaIdioma();
        } else if ($('[data-page]').attr('data-page') === 'case-skyn') {
          trocaIdioma();
        } else if ($('[data-page]').attr('data-page') === 'case-samsung') {
          trocaIdioma();
        }
      }, 1000);

    } else if (documentHTML[0].lang === "en") {
      documentHTML[0].lang = "pt";
      loaddingComponents();
      menuBuble();
      setTimeout(function () {
        // Troca o texto do menu e variável de verificação para português 
        $('[data-click="idioma"]').text('English');
        $('[data-click="idioma-footer"]').text('English');

        trocaIdioma();
      }, 1000);
    }
  };

  //Header
  (function () {
    //componente para o header do site (assim que carregado executa uma função)
    $('[data-html="header"]').load('components/header.html', function () {
    });
  })();

  //Menu flutuante
  (function () {
    $('[data-html="menu"]').load('components/menu.html', function () {
      const toSection = function toSection(el) {
        const elemento = $(`#${el}`),
          inTopTo = elemento.offset().top;
        $('html,body').animate({
          scrollTop: inTopTo
        }, 900);        
        window.history.pushState(el, el, `/index.html#${el}`);
      };

      //Menu do site
      $('.bubble-wrap').click(debounce(function () {
        menuAumenta();
      }, 200));

      $(document).scroll(debounce(function () {
        menuBuble(); 
      }, 200));

      $('[data-link="home"]').click(function (e) {
        const documentHTML = $('html');
        $('[data-page]').attr('data-page', 'home');
        e.preventDefault();
        loaddingComponents();
        setTimeout(function () {
          toSection('home');
        }, 500);
        home();
        animaCases = animaCasesP;
        if (documentHTML[0].lang === "en") {
          setTimeout(function () {
            trocaIdioma();
          }, 500);
        }
      });

      $('[data-link="cases"]').click(function (e) {
        e.preventDefault();
        loaddingComponents();
        home();
        setTimeout(function() {
          toSection('cases');
        }, 500);
      });

      $('[data-link="contato"]').click(function (e) {
        e.preventDefault();
        loaddingComponents();
        home();
        setTimeout(function() {
          toSection('contato');
        }, 500);
      });

      $('[data-click="idioma"]').click(function (e) {
        e.preventDefault();
        idiomas();
      });
    });
  })();

  //carousel de cases
  (function () {
    //componente para o carousel de cases (carousel mini antes do footer)
    $('[data-html="cases-carousel"]').load('components/cases-carousel.html', function () {
      $(".list__carrousel").owlCarousel({
        loop: true,
        margin: 10,
        autoplay: true,
        autoplayTimeout: 2000,
        autoplayHoverPause: true,
        responsive: {
          0: {
            items: 2
          },
          480: {
            items: 3
          },
          768: {
            items: 4
          }
        }
      });
    });
  })();

  // Home
  (function () {
    loadding();
    home();
  })();

  //Rodapé
  (function () {
    //Componente para o Footer do Site
    $('[data-html="footer"]').load('components/footer.html', function () {
      $('[data-click="idioma-footer"]').click(function (e) {
        e.preventDefault();
        idiomas();
      });
    });
  })();
});